<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>정보마당</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">정보마당</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/prepaymentinfo" title="주차요금정산">주차요금정산</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">묻고 답하기</p>
          <ul class="depth">
            <li><router-link to="/noticelist" title="공지사항">공지사항</router-link></li>
            <li><router-link to="/faqview" title="자주묻는질문">자주묻는질문</router-link></li>
            <li><router-link to="/qnalist" title="묻고 답하기">묻고 답하기</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">묻고 답하기</h3>
        <article>
          <div class="table horizontal-table noticeView">
            <table>
              <caption>
                묻고 답하기 상세 테이블
              </caption>
              <colgroup>
                <col style="width: 20%" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <td colspan="2">
                    <div class="tableTitle">
                      <p class="tit">{{ inquiry.title }}</p>
                      <div class="right">
                        <span class="writer">{{ inquiry.writer }}</span>
                        <span class="date">{{ inquiry.createdate }}</span>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" class="tableCont">
                    <pre name="" id="">
                                            {{ inquiry.content }}
                                        </pre
                    >
                  </td>
                </tr>
                <tr>
                  <th scope="row">첨부파일</th>
                  <td>
                    <article class="input-style button interval">
                      <div class="attach">
                        <div class="file-name">
                          <span
                            v-if="attachList"
                            class="cursor"
                            @click="
                              downloadAttachFile(
                                attachList.filePath,
                                attachList.saveNm,
                                attachList.viewNm,
                                attachList.fileExt,
                                attachList.repoId,
                              )
                            "
                          >
                            {{ attachList.viewNm }} ({{ attachList.fileSize | comma }})kb
                          </span>
                        </div>
                      </div>
                    </article>
                  </td>
                </tr>
                <tr>
                  <th scope="row">공개여부</th>
                  <td>{{ inquiry.nondisclosure ? '비공개' : '공개' }}</td>
                </tr>
                <tr>
                  <th scope="row">답변<span class="redDot">*</span></th>
                  <td>
                    <textarea v-model="answer.content" style="resize: none; min-height: 180px">내용작성 영역</textarea>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="linkMove">
            <a href="javascript:void(0);" class="prev"><p>이전글로 이동합니다.</p></a>
            <a href="javascript:void(0);" class="next disabled"><p>다음글로 이동합니다.</p></a>
          </div>
        </article>
        <article class="btnArea">
          <button type="button" class="btn border" @click="$router.push('qnalist')">목록</button>
          <button type="button" class="btn gray" @click="$router.push('qnalist')">취소</button>
          <button type="button" class="btn blue" @click="updateAnswer">저장</button>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';

export default {
  data() {
    return {
      firstName: '파일명',
      inquiryId: '',
      inquiry: {},
      answer: {},
      attachList: {},
    };
  },

  mounted() {
    const inquiryId = this.$route.query.inquiryId;
    if (!inquiryId) {
      alert('잘못된 접근입니다.');
      this.$router.push('/qnaview');
    }
    this.inquiryId = inquiryId;
    this.findInquiry();
  },

  methods: {
    async findInquiry() {
      const res = await axios('get', '/api/inquiry/admin', {
        inquiryId: this.inquiryId,
      });
      const data = res.data.result;
      this.attachList = res.data.attachList[0];
      this.inquiry = data.inquiry;
      if (data.answer) {
        this.answer = data.answer;
      }
    },

    async updateAnswer() {
      let apiParams = new FormData();
      apiParams.append('inquiryId', this.inquiryId);
      apiParams.append('respondent', this.$store.state.empNo);
      apiParams.append('content', this.answer.content);
      const res = await axios('post', '/api/inquiry/answer', apiParams);
      if (Object.keys(res.data).length === 0) {
        alert('답변 등록에 실패하였습니다.');
      } else {
        alert('답변이 등록 되었습니다.');
      }
      // await this.findInquiry();
      // alert("답변완료.");
    },

    downloadAttachFile(filePath, saveNm, viewNm, fileExt, repoId) {
      location.href =
        '/api/inquiry/download.json?filePath=' +
        filePath +
        '&saveNm=' +
        saveNm +
        '&viewNm=' +
        viewNm +
        '&fileExt=' +
        fileExt +
        '&repoId=' +
        repoId;
    },
  },
};
</script>
